import styled from 'styled-components';
import {TableContainerDefaultBox} from './table-container.default.box';
import {hexToRgba} from '../../../../../../../../themes/hex-to-rgba';

export const TableContainerBoxCasino777Box = styled(TableContainerDefaultBox)`
    font-size: 1.6rem;
    font-weight: 400;
    
    & td {            
        border-bottom: 1px solid ${props => hexToRgba(props.theme.colors.brandSecondaryDark, 0.5)};
        height:4rem;
    }
`;